 import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { HomeService } from 'src/app/services/home.service';

@Component({
  selector: 'app-collaborators',
  templateUrl: './collaborators.component.html',
  styleUrls: ['./collaborators.component.css']
})
export class CollaboratorsComponent implements OnInit {
  array:any=[]
  array2:any=[]
  arrayGetNameSection: any
  arrayCollaboratorCategory:any =[]
  arrayCollaboratorMember:any=[]
  selectedItem: any
  id: any
  load: boolean = false
  constructor(private home: HomeService, private _Activatedroute: ActivatedRoute) {
    this._Activatedroute.paramMap.subscribe(params => {
      window.scroll(0, 0);
      this.getAll();
    });
  }

  ngOnInit(): void {
  
  }
  getAll()
  {

    this.array = []
    this.array2=[]
    this.id = this._Activatedroute.snapshot.paramMap.get("id")

    if (this.id == null || this.id == '') {
      this.selectedItem = null
      this.home.getPost('getPost','', 'en', '', 'CollaboratorsCategory', 'NTROOT0', '', '-1').subscribe(data => {
        this.arrayCollaboratorCategory = data

        console.log('aa',data)
        let arr = data as []
        this.home.getPost('getPost', '', 'en', '', 'Collaborators', '', '', '-1').subscribe(data => {
          this.arrayCollaboratorMember = data

          let arr2 = data as []


          arr.forEach(el=>{


           arr2.forEach(el2=>{
                 if (el['postID'] == el2['parentID'])
                 {
                  this.array.push({postTitle:el2['postTitle'],postSubTitle:el2['postSubTitle'],postImage:el2['postImage'],collaborator_Linkedin:el2['collaborators_Linkedin'],collaborator_GoogleSchoolar:el2['collaborators_GoogleSchoolar'],collaborator_Publons:el2['collaborators_Publons'],postID:el2['postID']})
                 }
           })

           this.array2.push
           (
               {
                 Title:el['postTitle'],
                 ourCollaborators:this.array
               }
           )

               this.array = []
          })
          setTimeout(() => {
            this.load = true
          }, 2000);
        })
      })
    }
    else
    this.home.getPost('getPost','', 'en', '', 'CollaboratorsCategory', 'NTROOT0', '', '-1').subscribe(data => {
      this.arrayCollaboratorCategory = data

      let arr = data as []

    this.home.getPost('getPost', '', 'en', '', 'Collaborators', this.id, '', '-1').subscribe(data => {
          this.selectedItem = this.id
          this.arrayCollaboratorMember = data


          let arr2 = data as []


          arr.forEach(el=>{


           arr2.forEach(el2=>{
                 if (el['postID'] == el2['parentID'])
                 {
                  this.array.push({postTitle:el2['postTitle'],postSubTitle:el2['postSubTitle'],postImage:el2['postImage'],collaborator_Linkedin:el2['collaborators_Linkedin'],collaborator_GoogleSchoolar:el2['collaborators_GoogleSchoolar'],collaborator_Publons:el2['collaborators_Publons'],postID:el2['postID']})
                 }
           })

           this.array2.push
           (
               {
                 Title:el['postTitle'],
                 ourCollaborators:this.array
               }
           )

               this.array = []
          })


          setTimeout(() => {
            this.load = true
          }, 2000);
        })
      })
      console.log(this.array2)

    }
  getCollaborator(sectionId: string) {
    this.load = false

    this.selectedItem = sectionId

    this.home.getPost('getPost', '', 'en', '', 'Collaborators', "NTROOT0", '', '-1').subscribe(data => {
      this.arrayCollaboratorMember = data
        this.load = true
    })
  }
 
  }
